import { Wrapper } from './styled'
import { LoginWrapperProps } from './types'

const LoginWrapper = ({ children }: LoginWrapperProps) => {
  return <Wrapper>{children}</Wrapper>
}

export default LoginWrapper
